import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
import { nextjsPlugin } from '@datadog/browser-rum-nextjs';

const applicationId = process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
const site = process.env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.com';
const env = process.env.NEXT_PUBLIC_APP_ENV ?? 'development';
// 通常は next.config で実コミット SHA に解決済み。万一 "$VERCEL_GIT_COMMIT_SHA" の
// ような未展開プレースホルダが残っても Datadog のタグ警告を出さないよう無効化する。
const rawVersion = process.env.NEXT_PUBLIC_APP_VERSION;
const version = rawVersion && !rawVersion.startsWith('$') ? rawVersion : undefined;

// 候補者の同意画面（?token=）と求人の共有画面（/share/jobpost/{token}）の URL にはトークンが入る。
// Datadog に送る URL からは消す（docs/セキュリティTODO.md P3）
function scrubUrl(url: string): string {
  return url
    .replace(/([?&]token=)[^&#]*/g, '$1[REDACTED]')
    .replace(/(\/share\/jobpost\/)[^/?#]+/g, '$1[REDACTED]');
}

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service: 'byagent-front-monolith',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    plugins: [nextjsPlugin()],
    beforeSend: (event) => {
      event.view.url = scrubUrl(event.view.url);
      if (event.view.name) event.view.name = scrubUrl(event.view.name);
      if (event.view.referrer) event.view.referrer = scrubUrl(event.view.referrer);
      if (event.type === 'resource') event.resource.url = scrubUrl(event.resource.url);
      return true;
    },
  });

  datadogLogs.init({
    clientToken,
    site,
    service: 'byagent-front-monolith',
    env,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  });

  // The Next.js plugin sets trackViewsManually:true and starts views via
  // onRouterTransitionStart, which only fires on client-side navigation —
  // not initial SSR + hydration. Manually start the first view here.
  datadogRum.startView({ name: scrubUrl(window.location.pathname) });
}

export { onRouterTransitionStart } from '@datadog/browser-rum-nextjs';
